"use strict";

module.exports = Object.assign;
//# sourceMappingURL=object-assign.js.map